import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const layoutStyles = {
  main: {
    backgroundColor: '#f8f9fa',
    minHeight: 'calc(100vh - 62px)', // Tinggi header sekitar 62px
  },
  content: {
    padding: '20px',
  },
  footer: {
    backgroundColor: '#fff',
    borderTop: '1px solid #eee',
    padding: '15px 20px',
    textAlign: 'center',
    fontSize: '0.85rem',
    color: '#666',
  }
};

function Layout({ children }) {
  const location = useLocation();

  return (
    <div>
      <Header currentPath={location.pathname} />
      <main style={layoutStyles.main}>
        <div style={layoutStyles.content}>
          {children}
        </div>
      </main>
      <footer style={layoutStyles.footer}>
        <p>© {new Date().getFullYear()} CRM Umroh - Sistem Manajemen Jamaah</p>
      </footer>
    </div>
  );
}

export default Layout;